import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Field } from '../form';
import classNames from 'classnames'

import { currentProjectActiveDomainsSelector } from '../../reducers/selectors';
import map from 'lodash/map';
import find from 'lodash/find';
import size from 'lodash/size';

const mapStateToProps = state => ({ domains: currentProjectActiveDomainsSelector(state) });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch)
};

const DEFAULT_DOMAIN = 'shor.by'

const stopPropagation = (e) => {
  if (e && e.preventDefault){
    e.preventDefault();
    e.stopPropagation();
  }
}

class CustomDomainSelectorField extends Component {
  
  constructor (props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    }
  }
  
  toggle (e){
    this.setState({isOpen: !this.state.isOpen});
  }
  
  render () {
    const { name, domains } = this.props;
    const { isOpen } = this.state;
    const _domains = [{name: DEFAULT_DOMAIN, id: null}, ...domains];
    const hasCustomDomains = size(domains) > 0
    
    return (<Field
      name={name || 'domain_id'}
      render={({input})=>(<div className="domain-selector">
      <span className="gray" onClick={hasCustomDomains ? (e) => {stopPropagation(e); this.toggle()} : null}>
          {hasCustomDomains && <span className="toggler">{isOpen ? '▲' : '▼'}</span>}
          {(find(_domains, ['id', (input.value || null)]) || {name:DEFAULT_DOMAIN}).name + "/"}
        </span>
        {hasCustomDomains && <div className={classNames({"domains-dropdown": true, opened: isOpen})} onClick={this.toggle}>
          {map(_domains, (domain) => (
            <div key={domain.id || 0} className={classNames({"domain-item": true, selected: (input.value || null) === domain.id})} onClick={()=> input.onChange(domain.id)}>{domain.name}</div>
          ))}
        </div>}
      </div>)}
    />)
  }
}

export default  connect(mapStateToProps, matchDispatchToProps)(CustomDomainSelectorField);


// WEBPACK FOOTER //
// ./src/components/Links/CustomDomainSelectorField.js